import {
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormControl,
  Grid,
} from "@mui/material";
import { covOptionProvider, covPriceProvider } from "../providers/covProvider";
import Price from "../components/Price";

interface IProps {
  state: any;
  setState: (state: any) => void;
}

export default function ItemCOV(props: IProps) {
  const types = covOptionProvider();

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={5}>
        <FormControl fullWidth>
          <InputLabel>Velikost</InputLabel>
          <Select
            label="Velikost"
            value={props.state.type}
            size="small"
            onChange={(e) =>
              props.setState({ ...props.state, type: e.target.value })
            }
          >
            {types.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={2}>
        <FormControl fullWidth>
          <TextField
            label="Počet"
            size="small"
            value={props.state.quantity}
            onChange={(e) =>
              props.setState({ ...props.state, quantity: e.target.value })
            }
            type="number"
            inputProps={{ min: 0 }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={5}>
        <Price data={props.state} provider={covPriceProvider} />
      </Grid>
    </Grid>
  );
}
